import { PublishedFormIdUnion } from '@furnish-hx/constants/FormId';

const defaultConfigFormIds: PublishedFormIdUnion[] = [
    'swimmingPoolBuild',
    'swimingPoolLightingInstallation',
    'poolDeckDesignAndLayout',
    'aboveGroundPool',
    'arborDesignAndBuild',
    'bench',
    'benchAndStool',
    'chimneyBuild',
    'concreteFloor',
    'customBrazier',
    'customBuiltInCabinet',
    'customChimney',
    'customCupboard',
    'customCupboards',
    'customCurtainAndVeil',
    'customExteriorDoor',
    'customMadeVanityUnit',
    'customPantry',
    'customRugs',
    'designAndBuildOfGardenSheds',
    'stoneLaying',
    'dresserSideboard',
    'dressingTable',
    'exteriorShutter',
    'floorHeating',
    'flooringSale',
    'garageBuild',
    'garageLayout',
    'interiorShutter',
    'landscaping',
    'layoutAndBuildOfPoolHouse',
    'outdoorKitchenBuild',
    'playroomLayout',
    'pVCCarpentry',
    'sideTableAndBedsideTable',
    'staircaseDesign',
    'stairInstallation',
    'textileDecorationCurtainAndVeil',
    'wallHanging',
    'wallPaneling',
    'windowFilm',
    'bedroomDesign',
    'stool',
    'palisadeAndClaustra',
    'customKitchenCabinet',
    'customKitchenBaseCabinet',
    'kitchenIsland',
    'kitchenBack',
    'frenchWindow',
    'roofWindow',
    'slidingBayWindow',
    'frontDoor',
    'serviceDoor',
    'shutter',
    'sunBreeze',
    'gate',
    'grillageRigide',
    'balustrade',
    'porchDesignAndLayout',
    'gardenShelter',
    'tonelle',
    'interiorDoor',
    'customStorage',
    'officePedestals',
    'customCabinet',
    'trunk',
    'chestsOfDrawersAndCabinet',
    'customKitchenCupboard',
    'storageCupboard',
    'hallCabinet',
    'coatHanger',
    'nestingTable',
    'sofaAndpedestalTable',
    'pouf',
    'sofa',
    'endOfBed',
    'barChair',
    'barStool',
    'chair',
    'armchair',
    'bedhead',
    'light',
    'greenWall',
    'receptionDesk',
    'salesCounter',
    'showcase',
    'salesTable',
    'shelving',
    'row',
    'teaches',
    'tableMeeting',
    'sunbath',
    'nightstand',
    'bedroomLayout',
    'storageCabinet',
    'ground',
    'eatStandingUp',
    'phoneBox',
    'gardenPavilionDesignAndBuild',
];

export default defaultConfigFormIds;
